import React from 'react';
import LargeHeading from "../components/LargeHeading";

const Contact = (props) => {

    const sendEmail = () => {
        window.location.href = 'mailto:me@josh.kiwi?subject=Josh! Lets connect.';
    };

    return (
        <section className="contact" {...props}>
			<div className="trigger" />
            <div className="mail-icon" onClick={sendEmail.bind(this)}>
				<svg viewBox="0 0 100 100"><path d="M50,3.16A46.84,46.84,0,1,0,83.12,16.88,46.85,46.85,0,0,0,50,3.16ZM70.94,33.79,50,51.24,29.06,33.79Zm2.48,30.4a1.88,1.88,0,0,1-2,2H28.62a1.83,1.83,0,0,1-2-1.88V36.44l4.69,3.87L48.69,54.83a1.8,1.8,0,0,0,2.63,0L72.76,37l.66-.51V64.19Z"/></svg>
			</div>
            <LargeHeading
                title="&#109;&#101;&#64;&#106;&#111;&#115;&#104;&#46;&#107;&#105;&#119;&#105;"
                onClick={sendEmail.bind(this)}
            />
            <h3>Josh Warner</h3>
			<p className="text-center text-lg-left">Made in <span className="nz">New Zealand</span>, currently crushing it in <span className="au">Sydney</span>.</p>
        </section>
    );

};

export default Contact;


// WEBPACK FOOTER //
// ./src/js/views/Contact.js